import { Card, Row, Col, Typography, Form } from "antd";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { API } from "../config/api";
import { GET, POST } from "../utils/apicalls";
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography;

function Receptionist() {
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [VisitorsData, setVisitorsData] = useState<any>([]);
  const [ClientData, setClientData] = useState<any>([]);
  const [ProjectData, setProjectData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [employeeData, setEmployeeData] = useState<any>([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const data: any = await GET(url, {});
      setEmployeeData(data?.data || []);
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setEmployeeData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVisitors = async () => {
    try {
      setIsLoading(true);
      const url = API.GET_LISTING_VISITORS;
      const data: any = await GET(url, {});
      setVisitorsData(data?.data || []);
    } catch (error) {
      console.error("Error fetching visitors data:", error);
      setVisitorsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const data: any = await GET(url, {});
      setClientData(data?.data || []);
    } catch (error) {
      console.error("Error fetching client data:", error);
      setClientData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query"),
        page,
        take,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setProjectData(response?.data || []);
      setMeta(response?.meta || {});
    } catch (error) {
      console.error("Error fetching project data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployee();
    fetchVisitors();
    fetchClient();
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#f0f2f5",
        minHeight: "100vh",
      }}
    >
      <Title level={2} style={{ textAlign: "center", marginBottom: "30px" }}>
        Receptionist Dashboard
      </Title>

      <Row gutter={[16, 16]} justify="center">
        {/* Calendar Section */}
        <Col xs={24} md={12} lg={8}>
          <Card
            title={<Text strong>Calendar</Text>}
            style={{ borderRadius: "8px", textAlign: "center" }}
            bodyStyle={{ padding: "16px" }}
          >
            <Calendar />
          </Card>
        </Col>

        {/* Total Visitors Count */}
        <Col xs={24} md={12} lg={8}>
          <Card
            onClick={() => navigate(`/Receptionist/Visitors`)}
            title={<Text strong>Total Visitors</Text>}
            style={{
              borderRadius: "8px",
              backgroundColor: "#e6f7ff",
              textAlign: "center",
            }}
          >
            <Text style={{ fontSize: "24px", fontWeight: "bold" }}>
              {VisitorsData?.length || 0}
            </Text>
          </Card>
        </Col>

        {/* Total Projects Count */}
        <Col xs={24} md={12} lg={8}>
          <Card
            onClick={() => navigate(`/Receptionist/Project_Details`)}
            title={<Text strong>Total Projects</Text>}
            style={{
              borderRadius: "8px",
              backgroundColor: "#fff1b8",
              textAlign: "center",
            }}
          >
            <Text style={{ fontSize: "24px", fontWeight: "bold" }}>
              {meta.total_count || 0}
            </Text>
          </Card>
        </Col>

        <Col xs={24} md={12} lg={8}>
          <Card
            title={<Text strong>Total Employees</Text>}
            style={{
              borderRadius: "8px",
              backgroundColor: "#ffd6e7",
              textAlign: "center",
            }}
          >
            <Text style={{ fontSize: "24px", fontWeight: "bold" }}>
              {employeeData?.length || 0}
            </Text>
          </Card>
        </Col>

        {/* Total Clients Count */}
        <Col xs={24} md={12} lg={8}>
          <Card
            onClick={() => navigate(`/Receptionist/Client_Details`)}
            title={<Text strong>Total Clients</Text>}
            style={{
              borderRadius: "8px",
              backgroundColor: "#d9f7be",
              textAlign: "center",
            }}
          >
            <Text style={{ fontSize: "24px", fontWeight: "bold" }}>
              {ClientData?.length || 0}
            </Text>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Receptionist;
